var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"305935857bb96f8311773b24baa3a26635776bc6"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["planet-donations@plant-for-the-planet"]={id:"305935857bb96f8311773b24baa3a26635776bc6"};
      